import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useFormikContext } from "formik";
import Routes from "routing/Routes";
import useScopePermissions from "hooks/useScopePermissions";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import { Row } from "components/lookup-tables/layout-componets";
import useDefaultValueValidation from "./use-default-value-validation";
const ButtonsRow = styled(Row)`
  margin-top: ${({ theme }) => theme.spacings.lg};
`;
function WizardButtons({ isCreate, stepIds, activeStepId, onStepChange, isLoading }) {
  const { values, submitForm, resetForm, isValid } = useFormikContext();
  const { hasDefaultValueErrors } = useDefaultValueValidation();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(values);
  const navigate = useNavigate();
  const onFirstStep = useMemo(() => stepIds.indexOf(activeStepId) === 0, [stepIds, activeStepId]);
  const onLastStep = useMemo(() => stepIds.indexOf(activeStepId) === stepIds.length - 1, [stepIds, activeStepId]);
  const onPrev = () => {
    if (onFirstStep) return;
    const currentIndex = stepIds.indexOf(activeStepId);
    const newStepId = stepIds[currentIndex - 1];
    onStepChange(newStepId);
  };
  const onNext = () => {
    if (onLastStep) return;
    const currentIndex = stepIds.indexOf(activeStepId);
    const newStepId = stepIds[currentIndex + 1];
    onStepChange(newStepId);
  };
  const onSubmit = () => submitForm();
  const onCancel = () => {
    resetForm();
    navigate(Routes.SYSTEM.LOOKUPTABLES.OVERVIEW);
  };
  const canModify = useMemo(
    () => !values.id || !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable),
    [values.id, loadingScopePermissions, scopePermissions == null ? void 0 : scopePermissions.is_mutable]
  );
  if (activeStepId === "summary") {
    return /* @__PURE__ */ React.createElement(ButtonsRow, { $align: "center", $justify: "flex-end", $width: "100%" }, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "primary",
        onClick: onSubmit,
        disabled: !isValid || hasDefaultValueErrors || isLoading || !canModify
      },
      isLoading ? /* @__PURE__ */ React.createElement(Row, { $gap: "xs", $align: "center" }, /* @__PURE__ */ React.createElement(Spinner, { text: "" }), " ", /* @__PURE__ */ React.createElement("span", null, isCreate ? "Creating" : "Updating", " Lookup Table...")) : `${isCreate ? "Create" : "Update"} Lookup Table`
    ));
  }
  return /* @__PURE__ */ React.createElement(ButtonsRow, { $align: "center", $justify: "space-between", $width: "100%" }, /* @__PURE__ */ React.createElement(Button, { onClick: onPrev, disabled: onFirstStep }, "Previous"), /* @__PURE__ */ React.createElement(Button, { onClick: onNext }, "Next"));
}
export default WizardButtons;
